import type { CSSProperties, ComponentProps } from 'react';

import { getStaticPrefix } from '@eneco/common/env';
import { getClassNames } from '@eneco/sparky/util/css';

import { alignAndConstrainClass, stackContainerClass } from './accessmanagement.css';

const backgroundImages: Record<string, string> = {
  oxxio: '/images/oxxio/ox-bg-image-login.png',
  woonenergie: '/images/woonenergie/bg-image-login.png',
  eneco: '/images/eneco/background-loginregistration.jpg',
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const StackContainer: any = ({
  label,
  className,
  style: styleProp,
  ...props
}: ComponentProps<'div'> & { label?: string }) => {
  const imagePath = label ? backgroundImages[label] : undefined;
  const bgImageStyle = imagePath
    ? ({ '--stack-bg-image': `url(${getStaticPrefix()}${imagePath})`, ...styleProp } as CSSProperties)
    : styleProp;

  return <div className={getClassNames(stackContainerClass, className)} style={bgImageStyle} {...props} />;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const AlignAndConstrain: any = ({ className, ...props }: ComponentProps<'div'>) => (
  <div className={getClassNames(alignAndConstrainClass, className)} {...props} />
);
